import { logError } from '@office-start/telemetry-service';
import { logMosHubFeature } from './logMosHubFeature';
/**
 * Used to log telemetry logged by Hub SDK
 * @param params objet type AppHostInstrumentationParams
 */
export const logMosHubErrorAndFeature = (params) => {
    if (params.error) {
        logError({
            eventName: 'MOS_Hub_SDK_Error',
            errorType: 'MOS_Hub_SDK_Request_Error',
            message: params.error,
            area: 'MOSAppHost',
            subArea: params.scenarioName,
            debugInfo: `Error for appID: ${params.appId}, ClientTimeStamp: ${params.clientTimestamp}`,
        });
    }
    logMosHubFeature(params);
};
//# sourceMappingURL=logMosHubErrorAndFeature.js.map